import React, { useEffect, useState } from 'react';
import { ROUTE } from 'constant';
import Shared from 'screens/shared';
import { ACTIONS_TYPES } from 'redux/helper';
import { actions } from 'redux/actions';
import { formField, form } from 'types';
import { useSelector } from 'react-redux';

export default () => {
  const { [ACTIONS_TYPES.DATA_CENTER.GET_ALL]: dataCenters } = useSelector((e) => e);
  const [strapTitle, setStrapTitle] = useState('Sample Todo App');
  const [tasks, setTasks] = useState([
    {
      id: 1,
      task: 'This is pre-populated task 1',
      isCompleted: false,
    },
    {
      id: 2,
      task: 'This is pre-populated task 2',
      isCompleted: false,
    },
  ]);

  useEffect(() => {
    actions.dataCenter.getAll({});
  }, []);

  const addHandler = (values) => {
    setTasks([...tasks, { ...values, id: `${Math.random()}` }]);
    actions.notification.add({ action: ACTIONS_TYPES.AUTO_SCALING.GROUP.CREATE, message: 'Task has been created' });
  };

  const deleteHandler = ({ id }) => {
    setTasks([...tasks.filter((e) => e.id !== id)]);
  };

  const editHandler = ({ id, ...props }) => {
    setTasks([...tasks.map((e) => (e.id === id ? { ...e, ...props } : e))]);
  };

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.SAMPLE}
      // isStrap={false}
      strapIcon="home"
      strapTitle={strapTitle}
      strapSubTitle="This is a sample todo app"
      onDelete={() => {}}
      editForm={<Shared.forms.Form fields={[{ name: 'strapTitle', onChange: (e) => setStrapTitle(e) }]} onProps={{ strapTitle }} isCancel={false} />}
    >
      <Shared.widgets.Properties
        title="Tasks Details"
        properties={[
          ['Total tasks', tasks.length],
          ['Completed tasks', tasks.filter(({ isCompleted }) => isCompleted).length],
          ['Remaining tasks', tasks.filter(({ isCompleted }) => !isCompleted).length],
        ]}
      />

      <hr />

      <Shared.widgets.Section
        sectionTitle="Tasks"
        createForm={form({
          fields: [
            formField.text({
              name: 'task',
              title: 'Task',
            }),
            formField.switch({
              title: 'Is Completed',
              name: 'isCompleted',
            }),
            formField.text({
              name: 'reason',
              setTitle: (e) => `Reason ${e.task}`,
              setVisibility: (e) => e.isCompleted,
            }),
            formField.cdRom({
              name: 'image',
              setTitle: (e) => `Reason ${e.task}`,
            }),
          ],
          onSubmit: addHandler,
          isCancel: false,
        })}
        items={tasks}
        itemIcon="home"
        setItemTitle={(e) => e.task}
        setItemDetails={(e) => (e.isCompleted ? <Shared.widgets.Icon name="check" style={{ color: 'var(--color-success)' }} /> : 'In Progress')}
        // itemOnClick={(e) => console.log(e)}
        itemOnDelete={deleteHandler}
        itemOnEdit={editHandler}
        createActionType={ACTIONS_TYPES.AUTO_SCALING.GROUP.CREATE}
        setItemKey={(e) => e.id}
        setTableRows={(e) => [
          e.id, e.task,
          e.isCompleted ? <Shared.widgets.Icon name="check" style={{ color: 'var(--color-success)' }} /> : 'In Progress',
        ]}
        tableColumns={['Id', 'Task', 'Is Completed', '', '']}
        isDeletePassword
      />


      <Shared.widgets.Section
        sectionTitle="Servers"
        className="-m-t-24"
        items={dataCenters}
        itemIcon="server"
        setItemTitle={(e) => e?.properties?.name}
        setItemIconText={(e) => e?.properties?.location}
        setItemDetails={(e) => e?.properties?.location}
      />
    </Shared.widgets.Page>
  );
};
